"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.CustomerOrdersModal = void 0;
var AddCustomerOrder = _interopRequireWildcard(require("@ori-events/add-customer-order"));
var AddCustomerOrderFailed = _interopRequireWildcard(require("@ori-events/add-customer-order-failed"));
var BasketUpdated = _interopRequireWildcard(require("@ori-events/basket-updated"));
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _hooks = require("../hooks");
var _logger = require("../logger");
var _FormattedMessage = require("./FormattedMessage");
var _OrderRow = require("./OrderRow");
var _Total = require("./Total");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const INITIAL_ZERO_VALUE = '0';
const StyledDialog = (0, _mui.styled)(_components.Dialog)((param)=>{
    let { theme } = param;
    return {
        cursor: 'default',
        ["& .".concat(_components.dialogClasses.dialogGrid)]: {
            gridTemplateAreas: '\n    "header header header"\n    "content content content"\n    "footer footer footer"\n  '
        }
    };
});
const ModalInfo = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        paddingTop: theme.spacing(4),
        marginBottom: theme.spacing(3),
        [theme.breakpoints.up('sm')]: {
            textAlign: 'center'
        }
    };
});
const ModalOrdersAmount = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        paddingBottom: theme.spacing(2),
        borderBottom: "1px solid ".concat(theme.palette.grey[200])
    };
});
const OrderRowWrapper = (0, _mui.styled)('div')({
    marginBottom: 'auto'
});
const OrderRowContent = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(2, 0)
    };
});
const SelectedOrdersCountWrapper = (0, _mui.styled)('span')({
    fontWeight: 'bold'
});
const InformationSection = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        color: theme.palette.grey[600]
    };
});
const Hint = (0, _mui.styled)('span')((param)=>{
    let { theme } = param;
    return {
        fontWeight: 'bold',
        marginRight: theme.spacing(1)
    };
});
const TotalWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(3, 1, 0, 1),
        borderTop: "1px solid ".concat(theme.palette.grey[300]),
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            padding: theme.spacing(3, 2, 0, 2)
        }
    };
});
const Action = (0, _mui.styled)(_components.Button)((param)=>{
    let { theme } = param;
    return {
        margin: '0 auto',
        [theme.breakpoints.up('sm')]: {
            marginRight: 'initial',
            maxWidth: 'fit-content'
        }
    };
});
const LinkWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        padding: theme.spacing(3, 0),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(5, 0, 3),
            textAlign: 'center'
        }
    };
});
const addOrdersToBasket = async (orderIds)=>new Promise((resolve, reject)=>{
        const handleReject = (event)=>{
            window.removeEventListener(AddCustomerOrderFailed.Name, handleReject);
            // eslint-disable-next-line @typescript-eslint/no-use-before-define -- handleReject and handleResolve are using each other
            window.removeEventListener(BasketUpdated.Name, handleResolve);
            reject(event.detail.localizedMessage);
        };
        const handleResolve = ()=>{
            window.removeEventListener(BasketUpdated.Name, handleResolve);
            window.removeEventListener(AddCustomerOrderFailed.Name, handleReject);
            resolve();
        };
        window.addEventListener(BasketUpdated.Name, handleResolve);
        window.addEventListener(AddCustomerOrderFailed.Name, handleReject);
        const dispatchedEvent = new CustomEvent(AddCustomerOrder.Name, {
            detail: {
                orderIds
            }
        });
        window.dispatchEvent(dispatchedEvent);
    });
const CustomerOrdersModal = (param)=>{
    let { 'data-testid': testId, isOpen, onClose, ordersAmount, pendingOrders, ordersPageLink } = param;
    const { formatMessage } = (0, _hooks.useTranslations)();
    const [selectedOrdersCount, setSelectedOrdersCount] = (0, _react.useState)(INITIAL_ZERO_VALUE);
    const [totalAmountSelected, setTotalAmountSelected] = (0, _react.useState)(INITIAL_ZERO_VALUE);
    const [totalBp, setTotalBp] = (0, _react.useState)(INITIAL_ZERO_VALUE);
    const [selectedOrderIds, setSelectedOrderIds] = (0, _react.useState)([]);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [shouldReset, setShouldReset] = (0, _react.useState)(false);
    const closeAndReset = (0, _react.useCallback)((e)=>{
        onClose(e);
        setShouldReset((prevCheck)=>!prevCheck);
    }, [
        setShouldReset,
        onClose
    ]);
    const handleButtonClick = (0, _react.useCallback)((e)=>{
        setIsLoading(true);
        addOrdersToBasket(selectedOrderIds).then(()=>{
            closeAndReset(e);
        }).catch((error)=>{
            _logger.mainLogger.error(error, {
                action: 'addOrdersToBasket'
            });
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        selectedOrderIds,
        closeAndReset
    ]);
    const headerContent = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                    variant: "h5",
                    component: "div",
                    align: "center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                        id: "customerOrders"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ModalInfo, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                        id: "chooseTheCustomerOrders"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ModalOrdersAmount, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                        id: "selectedOrdersCount",
                        values: {
                            0: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectedOrdersCountWrapper, {
                                children: selectedOrdersCount
                            }),
                            1: ordersAmount
                        }
                    })
                })
            ]
        }), [
        ordersAmount,
        selectedOrdersCount
    ]);
    const footerContent = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InformationSection, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Hint, {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                                        id: "pleaseNote"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                                    id: "rememberToAlwaysContactYourCustomersPersonallyBeforeYouApproveAnyOrders"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkWrapper, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Link, {
                                variant: "button",
                                href: ordersPageLink,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                                    id: "editCustomerOrders"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TotalWrapper, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Total.Total, {
                            "data-testid": "".concat(testId, "-totals"),
                            totalAmountSelected: totalAmountSelected,
                            totalBp: totalBp
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Action, {
                            fullWidth: true,
                            variant: "outlined",
                            color: "default",
                            loading: isLoading,
                            "data-testid": "".concat(testId, "-submit"),
                            disabled: selectedOrderIds.length === 0,
                            onClick: handleButtonClick,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                                id: "add"
                            })
                        })
                    ]
                })
            ]
        }), [
        handleButtonClick,
        isLoading,
        ordersPageLink,
        selectedOrderIds.length,
        testId,
        totalAmountSelected,
        totalBp
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDialog, {
        closeAfterTransition: true,
        keepMounted: true,
        fullWidth: true,
        maxWidth: "785px",
        "data-testid": "".concat(testId, "-wrapper"),
        header: headerContent,
        "aria-label": formatMessage('customerOrders'),
        footer: footerContent,
        open: isOpen,
        onClose: closeAndReset,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OrderRowWrapper, {
            "data-testid": "".concat(testId, "-content"),
            children: pendingOrders === null || pendingOrders === void 0 ? void 0 : pendingOrders.map((item)=>item && /*#__PURE__*/ (0, _jsxRuntime.jsx)(OrderRowContent, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_OrderRow.OrderRow, {
                        "data-testid": "".concat(testId, "-row-").concat(item.endConsumerOrderId),
                        name: item.endConsumerName,
                        price: item.totalPrice,
                        bp: item.totalBp,
                        shouldReset: shouldReset,
                        setSelectedOrdersCount: setSelectedOrdersCount,
                        setTotalAmountSelected: setTotalAmountSelected,
                        setTotalBp: setTotalBp,
                        rowId: item.endConsumerOrderId,
                        priceValue: item.totalPriceValue,
                        setSelectedOrderIds: setSelectedOrderIds
                    })
                }, item.endConsumerOrderId))
        })
    });
};
exports.CustomerOrdersModal = CustomerOrdersModal;
var _default = exports.default = CustomerOrdersModal;
